import { createContext, useContext } from 'react';
import { CompanyStatsContextData as ContextData } from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useCompanyStatsContext = () => useContext(context);
